module.exports = __webpack_public_path__ + "static/img/fb.418fa01b.png";